// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/site/img/detail.white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../assets/site/img/route.white.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../assets/site/img/map.white.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.store {
    margin: 15px auto;
}

.store__h1 {
    font-size: var(--font-xl);
    font-family: "RalewaySemiBold";
    color: var(--color-granite);
    margin: 15px auto;
    text-align: center;
    padding: 0 15px;
}

.store__views {
    display: flex;
    justify-content: center;
    margin: 25px auto;
    padding: 0 15px;
    box-sizing: border-box;
}

.store__views-wrapper {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: auto;
    text-align: center;
}

.store__view {
    font-size: var(--font-m);
    box-sizing: border-box;
    padding: 10px 20px;
    border: 1px solid var(--color-main);
    border-right: 0;
}

.store__view.active {
    background-color: var(--color-main);
    color: var(--color-white);
}

.store__view:last-child {
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
    border-right: 1px solid var(--color-granite);
}

.store__view:first-child {
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
}

@media screen and (max-width: 1024px) {
    .store__views-wrapper {
    }

    .store__view {
        padding: 5px 15px;
    }
}


.store__content {
    display: flex;
    flex-direction: row;
}

@media screen and (max-width: 1024px) {
    .store__content {
        display: block;
    }
}

.store__cities {
    flex: 1 1 25%;
    box-sizing: border-box;
    padding: 15px;
}

@media screen and (max-width: 1024px) {
    .store__cities {
        display: block;
    }
}

.store__cities-list {
}

@media screen and (max-width: 1024px) {
    .store__cities-list {
        display: block;
    }
}

.store__cities-item {
    display: block;
    background-color: var(--color-white);
    color: var(--color-main);
    padding: 5px 15px;
    border-radius: 6px;
    font-size: var(--font-m);
    text-align: left;
}

.store__cities-item.active {
    color: var(--color-white);
    background-color: var(--color-main);
}

.store__data {
    flex: 1 1 75%;
}

.store__map {
    aspect-ratio: 1 / 1;
    display: none;
}

.store__list {
}

.baloon-body {
    padding: 15px 0;
    text-align: left;
    max-width: 75vw;
}

.baloon-item {
    margin: 5px 0;
}

.baloon-item__phone {
    margin: 15px 0;
    font-weight: bold;
    color: var(--color-main) !important;
    text-decoration: none !important;
    outline: none !important;
}

.baloon-footer {
    padding-bottom: 15px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-width: 75vw;
}

.baloon-button {
    border-right: 1px solid var(--color-gray-window);
    padding: 5px 15px;
    color: var(--color-granite);
    font-size: var(--font-m);
}

.baloon-button:last-child {
    border: 0;
}

.store__buttons {
    padding: 15px;
    text-align: center;
}

.store__list {
    padding: 0 15px 15px 15px;
}

.store_list__item {
    text-align: left;
    padding: 15px 15px;
    /*border-bottom: 1px solid var(--color-gray-window);*/
}

.store_list__item:first-child {
    padding-top: 0;
}

.store_list__item:last-child {
    border-bottom: 0;
}

.store_list__item:nth-child(2n) {
    background-color: #fafafa;
}

.store_list__title {
    font-size: var(--font-l);
    font-weight: bold;
    margin-bottom: 15px;
}

.store_list__text {
    font-size: var(--font-m);
    font-weight: normal;
    padding: 5px 0;
}

.store_list__phone {
    padding: 20px 0;
    font-size: var(--font-m);
    font-weight: bold;
    cursor: pointer;
    text-decoration: none !important;
    outline: none !important;
    color: var(--color-granite) !important;
    display: block;
}

.store_list__buttons {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 15px 0;
    flex-wrap: wrap;
}

.store_list__button {
    cursor: pointer;
    text-decoration: none !important;
    outline: none !important;
    color: var(--color-granite) !important;
    flex: 0 1 auto;
    box-sizing: border-box;
    padding: 0 20px;
    border-right: 1px solid var(--color-gray-window);
}

.store_list__button:last-child {
    border: 0;
}

@media screen and (max-width: 1024px) {
    .store_list__buttons {
        gap: 10px;
    }

    .store_list__button {
        border: 0;
        color: var(--color-white) !important;
        background-color: var(--color-main);
        border-radius: 6px;
        padding: 5px 20px 5px 10px;
    }

    .store_list__button.icon-detail:before {
        content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    }

    .store_list__button.icon-route:before {
        content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    }

    .store_list__button.icon-map:before {
        content: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
    }
}
`, "",{"version":3,"sources":["webpack://./resources/views/site/pages/storelist/main.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,8BAA8B;IAC9B,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,gDAAgD;IAChD,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;IACtB,kBAAkB;IAClB,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,gCAAgC;IAChC,4CAA4C;AAChD;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI;IACA;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;AACA;;AAEA;IACI;QACI,cAAc;IAClB;AACJ;;AAEA;IACI,cAAc;IACd,oCAAoC;IACpC,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,mCAAmC;AACvC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,aAAa;AACjB;;AAEA;AACA;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,mCAAmC;IACnC,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,oBAAoB;IACpB,aAAa;IACb,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gDAAgD;IAChD,iBAAiB;IACjB,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,qDAAqD;AACzD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,wBAAwB;IACxB,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,wBAAwB;IACxB,sCAAsC;IACtC,cAAc;IACd,sBAAsB;IACtB,eAAe;IACf,gDAAgD;AACpD;;AAEA;IACI,SAAS;AACb;;AAEA;IACI;QACI,SAAS;IACb;;IAEA;QACI,SAAS;QACT,oCAAoC;QACpC,mCAAmC;QACnC,kBAAkB;QAClB,0BAA0B;IAC9B;;IAEA;QACI,gDAA0D;IAC9D;;IAEA;QACI,gDAAyD;IAC7D;;IAEA;QACI,gDAAuD;IAC3D;AACJ","sourcesContent":[".store {\n    margin: 15px auto;\n}\n\n.store__h1 {\n    font-size: var(--font-xl);\n    font-family: \"RalewaySemiBold\";\n    color: var(--color-granite);\n    margin: 15px auto;\n    text-align: center;\n    padding: 0 15px;\n}\n\n.store__views {\n    display: flex;\n    justify-content: center;\n    margin: 25px auto;\n    padding: 0 15px;\n    box-sizing: border-box;\n}\n\n.store__views-wrapper {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    width: auto;\n    text-align: center;\n}\n\n.store__view {\n    font-size: var(--font-m);\n    box-sizing: border-box;\n    padding: 10px 20px;\n    border: 1px solid var(--color-main);\n    border-right: 0;\n}\n\n.store__view.active {\n    background-color: var(--color-main);\n    color: var(--color-white);\n}\n\n.store__view:last-child {\n    border-top-right-radius: 10px;\n    border-bottom-right-radius: 10px;\n    border-right: 1px solid var(--color-granite);\n}\n\n.store__view:first-child {\n    border-top-left-radius: 10px;\n    border-bottom-left-radius: 10px;\n}\n\n@media screen and (max-width: 1024px) {\n    .store__views-wrapper {\n    }\n\n    .store__view {\n        padding: 5px 15px;\n    }\n}\n\n\n.store__content {\n    display: flex;\n    flex-direction: row;\n}\n\n@media screen and (max-width: 1024px) {\n    .store__content {\n        display: block;\n    }\n}\n\n.store__cities {\n    flex: 1 1 25%;\n    box-sizing: border-box;\n    padding: 15px;\n}\n\n@media screen and (max-width: 1024px) {\n    .store__cities {\n        display: block;\n    }\n}\n\n.store__cities-list {\n}\n\n@media screen and (max-width: 1024px) {\n    .store__cities-list {\n        display: block;\n    }\n}\n\n.store__cities-item {\n    display: block;\n    background-color: var(--color-white);\n    color: var(--color-main);\n    padding: 5px 15px;\n    border-radius: 6px;\n    font-size: var(--font-m);\n    text-align: left;\n}\n\n.store__cities-item.active {\n    color: var(--color-white);\n    background-color: var(--color-main);\n}\n\n.store__data {\n    flex: 1 1 75%;\n}\n\n.store__map {\n    aspect-ratio: 1 / 1;\n    display: none;\n}\n\n.store__list {\n}\n\n.baloon-body {\n    padding: 15px 0;\n    text-align: left;\n    max-width: 75vw;\n}\n\n.baloon-item {\n    margin: 5px 0;\n}\n\n.baloon-item__phone {\n    margin: 15px 0;\n    font-weight: bold;\n    color: var(--color-main) !important;\n    text-decoration: none !important;\n    outline: none !important;\n}\n\n.baloon-footer {\n    padding-bottom: 15px;\n    display: flex;\n    justify-content: flex-start;\n    align-items: center;\n    max-width: 75vw;\n}\n\n.baloon-button {\n    border-right: 1px solid var(--color-gray-window);\n    padding: 5px 15px;\n    color: var(--color-granite);\n    font-size: var(--font-m);\n}\n\n.baloon-button:last-child {\n    border: 0;\n}\n\n.store__buttons {\n    padding: 15px;\n    text-align: center;\n}\n\n.store__list {\n    padding: 0 15px 15px 15px;\n}\n\n.store_list__item {\n    text-align: left;\n    padding: 15px 15px;\n    /*border-bottom: 1px solid var(--color-gray-window);*/\n}\n\n.store_list__item:first-child {\n    padding-top: 0;\n}\n\n.store_list__item:last-child {\n    border-bottom: 0;\n}\n\n.store_list__item:nth-child(2n) {\n    background-color: #fafafa;\n}\n\n.store_list__title {\n    font-size: var(--font-l);\n    font-weight: bold;\n    margin-bottom: 15px;\n}\n\n.store_list__text {\n    font-size: var(--font-m);\n    font-weight: normal;\n    padding: 5px 0;\n}\n\n.store_list__phone {\n    padding: 20px 0;\n    font-size: var(--font-m);\n    font-weight: bold;\n    cursor: pointer;\n    text-decoration: none !important;\n    outline: none !important;\n    color: var(--color-granite) !important;\n    display: block;\n}\n\n.store_list__buttons {\n    display: flex;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    padding: 15px 0;\n    flex-wrap: wrap;\n}\n\n.store_list__button {\n    cursor: pointer;\n    text-decoration: none !important;\n    outline: none !important;\n    color: var(--color-granite) !important;\n    flex: 0 1 auto;\n    box-sizing: border-box;\n    padding: 0 20px;\n    border-right: 1px solid var(--color-gray-window);\n}\n\n.store_list__button:last-child {\n    border: 0;\n}\n\n@media screen and (max-width: 1024px) {\n    .store_list__buttons {\n        gap: 10px;\n    }\n\n    .store_list__button {\n        border: 0;\n        color: var(--color-white) !important;\n        background-color: var(--color-main);\n        border-radius: 6px;\n        padding: 5px 20px 5px 10px;\n    }\n\n    .store_list__button.icon-detail:before {\n        content: url(../../../../assets/site/img/detail.white.svg);\n    }\n\n    .store_list__button.icon-route:before {\n        content: url(../../../../assets/site/img/route.white.svg);\n    }\n\n    .store_list__button.icon-map:before {\n        content: url(../../../../assets/site/img/map.white.svg);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
